module.exports = __webpack_public_path__ + "common/images/cards-680dfaf13e3e7d56f0c861cdf7925fde.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/common/images/cards.svg
// module id = 62
// module chunks = 0 1 2